import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AnimatePresence, motion } from "framer-motion";

import PanelDev from 'panels/dev/PanelDev';

import PanelMedia from 'panels/media/PanelMedia';
import PanelClient from 'panels/media/PanelClient';
import PanelGallery from 'panels/media/PanelGallery';
import PanelPDFs from 'panels/media/PanelPDFs';
import PanelFImage from 'panels/media/PanelFImage';

export default function LayoutMedia() {

    const [isOpen, setIsOpen] = useState(true);

    const { page } = useParams();

    const navigate = useNavigate();

    const itemVariants = {
        closed: { opacity: 0 },
        open: { opacity: 1 }
    };

    const changeNav = (link) => {
        navigate(`/home/${link}`);
        setIsOpen(true);
    }

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <AnimatePresence>
                {
                    isOpen && <motion.div initial={{ width: 0 }} animate={{ width: '16rem' }} exit={{ width: 0, transition: { delay: 0.2, duration: 0.3 } }} className="w-56 lg:w-64 h-screen bg-slate-100">
                        <motion.h1 initial="closed" animate="open" exit="closed" variants={itemVariants} className="text-xl lg:text-2xl font-medium pt-4 ml-6">Media Menu</motion.h1>
                        <motion.ul initial="closed" animate="open" exit="closed" variants={itemVariants} className="w-64 flex flex-col items-start mt-2 lg:mt-4">
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'media' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('media') }}>Media Center</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'clients' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('clients') }}>Clients</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'gallery' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('gallery') }}>Gallery</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'pdfs' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('pdfs') }}>PDFs</li>
                            <li className={`cursor-pointer text-base lg:text-lg ml-4 lg:ml-6 px-2 py-2 lg:py-3 ${page === 'footerImg' ? 'text-prime font-bold' : 'text-black hover:font-bold'}`} onClick={() => { changeNav('footerImg') }}>Footer Image</li>
                        </motion.ul>
                    </motion.div>
                }
            </AnimatePresence>
            <div className='h-screen w-full'>
                {
                    (() => {
                        switch (page) {
                            case 'media':
                                return (<PanelMedia />);
                            case 'clients':
                                return (<PanelClient />);
                            case 'gallery':
                                return (<PanelGallery />);
                            case 'pdfs':
                                return (<PanelPDFs />);
                            case 'footerImg':
                                return (<PanelFImage />);
                            default:
                                return (<PanelDev />);
                        }
                    })()
                }
            </div>
        </>
    )
}
